import React, { useEffect, useState } from "react";
import "./Login.css";
import { Formik } from "formik";
import { Input } from "formik-antd";
import axios from "axios";
import { message } from "antd";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Backdrop, CircularProgress } from "@mui/material";
import * as Yup from "yup";

const Login = () => {
  const [initialState, setInitialState] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  return (
    <div className="auth-wrapper">
      <div className="auth-inner">
        <Formik
          initialValues={initialState}
          onSubmit={(values) => {
            sessionStorage.clear();
            var url = window.API_PREFIX + "users/api/post/login";
            const requestOptions = {
              data: values,
            };
            setLoading(true);
            axios
              .post(url, requestOptions)
              .then((res) => {
                if (res.status == 200) {
                  sessionStorage.setItem("token", res.data["jwt"]);
                  sessionStorage.setItem("username", res.data["username"]);
                  sessionStorage.setItem("role", res.data["role"]);
                  sessionStorage.setItem("name", res.data["name"]);
                  if (res.data["role"] == "Student") {
                    // if (!res.data["is_email_verified"]) {
                    //   window.location = "/verify";
                    // } else {
                    //   window.location = "/form";
                    // }
                    window.location = "/form";
                  } else if (res.data["role"] == "Verifier") {
                    window.location = "/Admin/Verifier";
                  } else if (res.data["role"] == "Admin") {
                    window.location = "/Admin/Dashboard/User_Approval";
                  } else {
                    window.location = "/waiting";
                  }
                }
              })
              .catch((err) => {
                message.error(err.response.data.detail);
              })
              .finally(() => {
                setLoading(false);
              });
          }}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values, setFieldValue, touched, errors }) => (
            <div>
              <h3>Sign In</h3>

              <div className="mb-3">
                <label>Email address</label>
                <Input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  name="email"
                />
                {errors.email && touched.email && (
                  <span style={{ color: "red" }}>{errors.email}</span>
                )}
              </div>

              <div className="mb-3">
                <label>Password</label>
                <Input.Password
                  placeholder="Enter password"
                  name="password"
                  iconRender={(visible) =>
                    visible ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />
                  }
                />
                {errors.password && touched.password && (
                  <span style={{ color: "red" }}>{errors.password}</span>
                )}
              </div>

              <div className="d-grid">
                <button type="submit" className="btn" onClick={handleSubmit}>
                  Submit
                </button>
              </div>

              <div className="d-grid row">
                <div className="col forgot-password text-left">
                  <a href="SignUp">Register!</a>
                </div>
                <div className="col forgot-password text-right">
                  Forgot <a href="#">password?</a>
                </div>
              </div>
            </div>
          )}
        </Formik>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
};

export default Login;
